export default __webpack_public_path__ + "static/media/cpp.3869c4da.svg";